import "./DrSoto.module.css";
import NavegaciNPrincipal from "@/reusable_sections/Header";
import LaExperienciaDeLaDraSoto from "./sections/LaExperienciaDeLaDraSoto";
import TrayectoriaYCredenciales from "./sections/TrayectoriaYCredenciales";
import ValoresDelInstituto from "./sections/ValoresDelInstituto";
import PieDePGinaInstitucional from "@/reusable_sections/Footer";
export default function DrSotoPage() {
  return <div>
      <NavegaciNPrincipal />
      <LaExperienciaDeLaDraSoto />
      <TrayectoriaYCredenciales />
      <ValoresDelInstituto />
      <PieDePGinaInstitucional />
    </div>;
}